import { useCallback, useState } from 'react';
import { canActivateNow } from '../utils';
import { TIMEOUT_DURATION } from '../utils/Constants';
import useR05Api from '../api/useR05Api';
import { OrderTicket } from 'types';

const useDirectUseTicket = () => {
    const [orderTicket, setOrderTicket] = useState<OrderTicket>();
    const [isLoading, setLoading] = useState(false);
    const [canUseDirect, setCanUseDirect] = useState(false);
    const { fetchOrderDetail, fetchHolidays } = useR05Api();

    const showError = useCallback((error: any) => {
        console.log(error);
    }, []);

    const fetchOrder = useCallback(
        async (orderId: string) => {
            let timeoutId;
            try {
                setLoading(true);
                timeoutId = setTimeout(() => {
                    setLoading(false);
                    showError({ errorType: 'timeout' });
                }, TIMEOUT_DURATION);

                if (!navigator.onLine) {
                    clearTimeout(timeoutId);
                    setLoading(false);
                    showError({ errorType: 'offline' });
                }

                const order = await fetchOrderDetail({
                    orderId: orderId,
                    orderTicketId: null,
                });
                const holidays = await fetchHolidays();
                if (order != null && order?.comboItems?.length > 0 && !order.isCombination) {
                    const orderTicket: OrderTicket = { ...order, ...order.comboItems[0], holidays };
                    setOrderTicket(orderTicket);
                    setCanUseDirect(canActivateNow(orderTicket));
                    clearTimeout(timeoutId);

                    // 正常系終了
                } else {
                    setLoading(false);
                    showError({ errorType: 'not_single_ticket' }); //単券ではありません
                    clearTimeout(timeoutId);
                }
            } catch (error) {
                clearTimeout(timeoutId);
                showError(error);
            } finally {
                setLoading(false);
            }
        },
        [fetchHolidays, fetchOrderDetail, showError],
    );

    return { isLoading, orderTicket, canUseDirect, fetchOrder };
};

export default useDirectUseTicket;
